/**
 * Staff Performance Table Component
 * Displays staff metrics in tabular format
 */

import React from 'react';

export default function StaffPerformanceTable({ staffMetrics }) {
  if (!staffMetrics || staffMetrics.length === 0) {
    return (
      <div className="text-center py-12 text-gray-500">
        No staff performance data available
      </div>
    );
  }

  return (
    <div className="overflow-x-auto">
      <table className="w-full">
        <thead>
          <tr className="border-b border-gray-200">
            <th className="text-left text-xs font-semibold text-gray-600 pb-3">Staff Member</th>
            <th className="text-right text-xs font-semibold text-gray-600 pb-3">Open</th>
            <th className="text-right text-xs font-semibold text-gray-600 pb-3">Resolved</th>
            <th className="text-right text-xs font-semibold text-gray-600 pb-3">Avg Time</th>
            <th className="text-right text-xs font-semibold text-gray-600 pb-3">SLA %</th>
          </tr>
        </thead>
        <tbody>
          {staffMetrics.slice(0, 10).map((staff, index) => (
            <tr key={index} className="border-b border-gray-100">
              <td className="py-3 text-sm text-gray-900">{staff.staff_name}</td>
              <td className="py-3 text-sm text-right text-gray-600">
                {staff.current_open_tickets}
              </td>
              <td className="py-3 text-sm text-right text-gray-600">
                {staff.tickets_resolved_30d}
              </td>
              <td className="py-3 text-sm text-right text-gray-600">
                {Math.round(staff.avg_resolution_minutes_30d / 60) || 0}h
              </td>
              <td className="py-3 text-sm text-right">
                <span
                  className={`px-2 py-1 rounded-full text-xs font-medium ${
                    staff.first_response_sla_compliance_pct_30d >= 90
                      ? 'bg-green-100 text-green-800'
                      : staff.first_response_sla_compliance_pct_30d >= 75
                      ? 'bg-yellow-100 text-yellow-800'
                      : 'bg-red-100 text-red-800'
                  }`}
                >
                  {staff.first_response_sla_compliance_pct_30d || 0}%
                </span>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
